var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{on:{"cart-ref":_vm.setCartRef}}),_c('AdminHomeContent',{attrs:{"cart-component":_vm.cartComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }